<template lang="pug">
  div
    form.sign-up-form(role='form', @submit="submit")
      .form-group(v-if="forgotPassword == 'notFoundEmail'", :class='classes("message")') {{$t('connection.messages.noUserWithEmail')}}
      .form-group(v-if="forgotPassword == 'sent'", :class='classes("message")') {{$t('connection.messages.emailSent')}}
      .form-group(v-if="loginState == 'networkError'", :class='classes("message")') {{$t('connection.messages.noConnection')}}
      .form-group(v-if="subscribing == 'error'", :class='classes("message")') {{$t('connection.messages.fieldsErrors')}}
      .form-group(v-if="subscribing == 'errorEmailExists'", :class='classes("message")') {{$t('connection.messages.alreadyUsedEmail')}}
      .form-group(v-if="loginState == 'socialError'", :class='classes("message")') {{$t('connection.messages.errorOnSocialAccount')}}
      .form-group(v-if="needConfirmPasswordForSocial", :class='classes("message")') {{$t('connection.messages.socialAccountWithExistingEmail')}}
      .form-group(v-if="loginState == 'error'", :class='classes("message")') {{$t('connection.messages.badCredentials')}}
      .form-group(v-if='forgotPassword === true') {{$t('connection.messages.forgetPasswordEnterEmail')}}
      template(v-if='!forgotPassword')
        .form-group(:class="classes('form-group')")
          input#signinemail.form-control(type='text', :placeholder='emailPlaceholder', v-model="username", :disabled="connectionInputDisabled || needConfirmPasswordForSocial", @keyup.enter="tryLoginOrTrySubscribe", ref="emailInput", v-if="forgotPassword != 'sent'", name="email")
        .form-group(:class="classes('form-group')")
          input#signinpassword.form-control(type='password', :placeholder='$t("connection.placeholders.password")', v-model="password", :disabled="connectionInputDisabled", ref="passwordInput", @keyup.enter="tryLoginOrTrySubscribe", name="password")
        template(v-if="subscribing")
          .form-group(:class="classes('form-group')")
            input.form-control(type='password', :placeholder='$t("connection.placeholders.confPassword")', v-model="confPassword", :disabled="connectionInputDisabled", ref="confPasswordInput", @keyup.enter="tryLoginOrTrySubscribe", name="confPassword")
            .helper-block(v-if="!passwordAreIdentical") {{$t('connection.messages.passwordsAreNotSame')}}
          .form-group(:class="classes('form-group')")
            input.form-control(type='text', :placeholder='$t("connection.placeholders.name")', v-model="name", :disabled="connectionInputDisabled", @keyup.enter="tryLoginOrTrySubscribe", name="name")
      //- forget password
      template(v-else)
        .form-group(:class="classes('form-group')")
          input.form-control(type='text', :placeholder='emailPlaceholder', v-model="username", :disabled="connectionInputDisabled", @keyup.enter="sendForgotPassword", v-if="forgotPassword != 'sent'", name="recoveringEmail")
    template(v-if='!forgotPassword')
      .socialBtnsRow(style="clear: both; text-align: center")
        a#sign-up.sign-up-button.btn(href='#', :disabled="connectionInputDisabled", @click.stop.prevent="trySubcribe", :class='classes("button")', v-if='!needConfirmPasswordForSocial') {{$t('connection.buttons.signup')}}
        a#sign-in.sign-up-button.btn.clickable(data-wow-delay='1s', :disabled="connectionInputDisabled", @click.stop.prevent="stopSubscribing", :class='classes("button")', v-if="subscribing || needConfirmPasswordForSocial") {{$t('globals.cancel')}}
        a#sign-in.sign-up-button.btn.clickable(data-wow-delay='1s', :disabled="connectionInputDisabled", @click.stop.prevent="tryLogin", :class='classes("button")', v-if="!subscribing")
          template(v-if="!connectionInputDisabled") {{$t('connection.buttons.signin')}}
          template(v-else) 
            i.fa.fa-refresh.fa-spin

      .socialBtnsRow(style="clear: both; text-align: center")
        button.btn.wow.fadeInUp(@click="logWithFacebook", :disabled="connectionInputDisabled", v-if="!needConfirmPasswordForSocial", :class='classes("socialButton")')
          template(v-if="loginState != 'socialLoading' && loginState != 'socialConnected'") 
            i.fa.fa-facebook
            |  {{$t('connection.buttons.byFacebook')}}
          template(v-else) 
            i.fa.fa-refresh.fa-spin
        button.btn.wow.fadeInUp(@click="logWithGoogle", :disabled="connectionInputDisabled", v-if="!needConfirmPasswordForSocial", :class='classes("socialButton")')
          template(v-if="loginState != 'socialLoading' && loginState != 'socialConnected'") 
            i.fa.fa-google
            |  {{$t('connection.buttons.byGoogle')}}
          template(v-else) 
            i.fa.fa-refresh.fa-spin  
      .forgetPassword(v-if='!subscribing')
        a(role='button', @click="forgotPassword = true; loginState = null") {{$t('connection.buttons.forgotPassword')}}
    template(v-else-if="forgotPassword != 'sent'")
      .socialBtnsRow(style="clear: both; text-align: center")
        a#sign-up.sign-up-button.btn(href='#', :disabled="connectionInputDisabled", @click.stop.prevent="sendForgotPassword", :class='classes("button")') {{$t('connection.buttons.sendMailForPassword')}}
        a#sign-in.sign-up-button.btn.clickable(data-wow-delay='1s', :disabled="connectionInputDisabled", @click.stop.prevent="forgotPassword = false", :class='classes("button")') {{$t('globals.cancel')}}
    template(v-else)
        .socialBtnsRow(style="clear: both; text-align: center")
          a#sign-in.sign-up-button.btn.clickable(data-wow-delay='1s', :disabled="connectionInputDisabled", @click.stop.prevent="forgotPassword = false", :class='classes("button")') {{$t('connection.buttons.backToSingIn')}}
</template>
<script type="text/javascript">
import api from '@/utils/api'
import hello from 'hellojs'

import authService from '@/utils/authService'

export default {
  props: {
    classes: {
      type: Function,
      required: false,
      default (elem) {
        return {
          'message': 'col-md-offset-4 col-md-4 col-md-offset-4',
          'form-group': 'col-md-offset-4 col-md-4 col-md-offset-4',
          'button': 'btn-border btn-lg',
          'socialButton': 'btn-border btn-lg'
        }[elem]
      }
    }
  },
  data () {
    return {
      username: '',
      password: '',
      confPassword: '',
      name: '',
      loginState: null,
      needConfirmPasswordForSocial: false,
      extraDataForSocial: {},
      subscribing: false,
      forgotPassword: false
    }
  },
  mounted () {
    hello.init(process.env.helloOptions, {})

    // hello.logout('google')
    // hello.logout('facebook')

    hello.on('auth.login', (auth) => {
      return hello(auth.network).api('me', {
        key: 'AIzaSyD8tdyHmgKjBjKOrSyYPGhIIP1EJIJDQdw'}).then((r) => {
          return api.get('social/login',
            {
              __noToken: true,
              params: {
                network: auth.network,
                userid: r.id,
                lang: this.$i18n.locale,
                token: auth.authResponse.access_token
              }
            }).then((response) => {
              let data = response.data
              if (data.needPassword) {
                this.username = data.email
                this.extraDataForSocial = {
                  network: auth.network,
                  userid: r.id,
                  token: auth.authResponse.access_token
                }
                this.needConfirmPasswordForSocial = true
                this.loginState = null
              } else {
                authService.setToken(data.token.access_token, data.token.expires_in, data.token.refresh_token)
                this.loginState = 'connected'
                setTimeout(() => {
                  this.loginState = null
                }, 1000)

            // api.setToken(data.token.access_token, data.token.refresh_token, data.token.expires_in)
            // return api.trigger('newToken')
              }
            }).fail(() => {
              this.loginState = 'socialError'
            })
        }, () => {
          this.loginState = 'socialError'
        })
    })
  },
  destroyed () {
    hello.off('auth.login')
  },
  computed: {
    connectionInputDisabled: function () {
      return this.loginState === 'loading' || this.loginState === 'socialLoading' || this.loginState === 'connected' || this.loginState === 'socialConnected'
    },
    passwordAreIdentical: function () {
      return this.confPassword === '' || this.confPassword === this.password
    },
    emailPlaceholder: function () {
      if (this.subscribing || this.forgotPassword) {
        return this.$i18n.t('connection.placeholders.email')
      } else {
        return this.$i18n.t('connection.placeholders.login')
      }
    },
    emailType () {
      if (this.subscribing) {
        return 'email'
      } else {
        return 'text'
      }
    }
  },
  methods: {
    tryLoginOrTrySubscribe (event) {
      event.preventDefault()
      if (this.subscribing) {
        return this.trySubcribe()
      } else {
        return this.tryLogin()
      }
    },
    submit (event) {
      event.preventDefault()
      if (this.forgotPassword) {
        this.sendForgotPassword(event)
      } else {
        this.tryLoginOrTrySubscribe(event)
      }
    },
    tryLogin () {
      this.subscribing = false
      this.loginState = 'loading'
      return this.$store.dispatch('user/tryLogin', {
        username: this.username,
        password: this.password,
        extraDataForSocial: this.extraDataForSocial
      }).then(() => {
        this.loginState = 'connected'
        setTimeout(() => {
          this.loginState = null
        }, 1000)
      }).catch((error) => {
        if (error.message === 'Network Error') {
          this.loginState = 'networkError'
        } else {
          this.loginState = 'error'
        }
      })
    },
    logWithFacebook (event) {
      var data
      event.preventDefault()
      data = {
        scope: 'email'
      }
      return this.logWithSocial('facebook', data)
    },
    logWithGoogle (event) {
      var data
      event.preventDefault()
      data = {
        scope: 'email'
      }
      return this.logWithSocial('google', data)
    },
    logWithSocial (network, data) {
      // var timeout
      this.subscribing = false
      this.loginState = 'socialLoading'
      setTimeout(() => {
        if (this.loginState === 'socialLoading') {
          this.loginState = null
        }
      }, 2000)
      hello(network).login(data, (response) => {
        if (response.error && response.error.code) {
          this.loginState = 'socialError'
        } else {
          this.loginState = 'socialConnected'
        }
      })
    },
    stopSubscribing (event) {
      this.loginState = null
      this.subscribing = false
      this.needConfirmPasswordForSocial = false
    },
    trySubcribe: function (event) {
      this.loginState = null
      if (!this.subscribing) {
        this.subscribing = true
        this.$nextTick(() => {
          if (this.username === '') {
            this.$refs.emailInput.focus()
          } else if (this.password === '') {
            this.$refs.passwordInput.focus()
          } else {
            this.$refs.confPasswordInput.focus()
          }
        })
      } else {
        if (this.username.trim() === '' || this.password !== this.confPassword || this.name.trim() === '') {
          this.subscribing = 'error'
        } else {
          return api.post('/signin',
            {
              email: this.username,
              firstname: this.name,
              password: this.password,
              lang: this.$i18n.locale
            }, {
              __noToken: true
            }
          ).then((response) => {
            return this.$store.dispatch('user/tryLogin', {
              username: this.username,
              password: this.password
            })
          }).catch((error) => {
            if (error.response.data.error === 'EmailExists') {
              this.subscribing = 'errorEmailExists'
            } else {
              this.subscribing = 'error'
            }
          })
        }
      }
    },
    sendForgotPassword () {
      api.get('forgetPassword', {params: {email: this.username}, __canHaveNoToken: true}).then(() => {
        this.forgotPassword = 'sent'
      }).catch(() => {
        this.forgotPassword = 'notFoundEmail'
      })
    }
  },
  watch: {
    needConfirmPasswordForSocial () {
      return this.$nextTick(() => {
        return this.$refs.passwordInput.focus()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Connection.vue?3269ebc8